import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';
import { TmCreditCard, TmCreditCardType } from '../../tscapi/model/account';
import { TmInstallmentBreakdown } from '../../tscapi/model/cart';
import { TmCartInstallmentRequest } from '../../tscapi/model/request/cart-request';

export const PaymentOption = () => {
    const { cartData, updateInstallment, orderModificationMode, modifiedOrderSummary } = useContext(CartContext);
    const [availableInstallmentBreakdown, setAvailableInstallmentBreakdown] = useState<TmInstallmentBreakdown[]>();
    const [selectedEasyPay, setSelectedEasyPay] = useState(1);
    const [installmentErrorMessage, setErrorMessage] = useState('');
    const { t } = useTranslation();

    const updateCartInstallment = (e) => {
        const easypayReq = new TmCartInstallmentRequest();
        easypayReq.NoOfInstallments = e.target.value;

        updateInstallment(easypayReq);
    };

    useEffect(() => {
        let selectedCreditCard: TmCreditCard;
        const isTSCCreditCardSelected = false;
        let isRogersCreditCardSelected = false;
        let promotionalEasyPayInstallment: TmInstallmentBreakdown;

        let installments = null;
        if (cartData && cartData.Buyer) {
            if (cartData && cartData.AvailableInstallmentsBreakdown != null) {
                installments = cartData.AvailableInstallmentsBreakdown;
            }
            if (cartData.OrderSummary.EasyPay && cartData.OrderSummary.EasyPay.NoOfInstallments) {
                setSelectedEasyPay(cartData.OrderSummary.EasyPay.NoOfInstallments);
            } else {
                setSelectedEasyPay(1);
            }
            if (installments) {
                if (cartData.CreditCard) {
                    selectedCreditCard = cartData.CreditCard;
                    isRogersCreditCardSelected = selectedCreditCard.IsIssuerRogers;
                    promotionalEasyPayInstallment = cartData.PromotionalEasyPayInstallment;
                    if (
                        isRogersCreditCardSelected &&
                        promotionalEasyPayInstallment &&
                        installments.findIndex(
                            (x) => x.NoOfInstallments == promotionalEasyPayInstallment.NoOfInstallments,
                        ) < 0
                    ) {
                        installments.push(promotionalEasyPayInstallment);
                    }
                    setAvailableInstallmentBreakdown(installments);
                } else {
                    setAvailableInstallmentBreakdown(installments);
                }
            }
        }
    }, [cartData]);

    return (
        <div className="paymentOptionWrap">
            <div className="paymentoption__label">
                <h2>{t('Payment Option')}</h2>
                <div className="paymentoption__text"> {t('Taxes & Shipping excluded')} </div>
            </div>
            <div className="paymentoption__description">
                <div className="paymentoption__select-wrap">
                    {!orderModificationMode &&
                        cartData &&
                        availableInstallmentBreakdown != null &&
                        (availableInstallmentBreakdown.length > 1 && cartData.PaymentMethod != 'PY' ? (
                            <select className="form__select" onChange={updateCartInstallment} value={selectedEasyPay}>
                                {availableInstallmentBreakdown.map((payments) => (
                                    <option key={payments.NoOfInstallments} value={payments.NoOfInstallments}>
                                        {payments.MonthlyPayment}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            availableInstallmentBreakdown.length >= 1 && (
                                <div>
                                    <span> {availableInstallmentBreakdown[0].MonthlyPayment} </span>
                                    {availableInstallmentBreakdown.length > 1 && (
                                        <div className="paymentoption__paypal-note--wrap">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                className="paymentoption__paypal-svg"
                                            >
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                                            </svg>
                                            <div className="paymentoption__paypal-note">
                                                PayPal cannot be used as a payment method for orders with Easy Pays.
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        ))}

                    {orderModificationMode && modifiedOrderSummary && (
                        <>
                            {modifiedOrderSummary.EasyPay ? (
                                <span>
                                    {modifiedOrderSummary.EasyPay.NoOfInstallments} Payments of{' '}
                                    {modifiedOrderSummary.EasyPay.FutureMonthlyPayment}
                                </span>
                            ) : (
                                <span>{t('One Payment of', { orderTotal: modifiedOrderSummary.GrandTotal })}</span>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
